export function CoachLine({ children, subtitle }) {
  return (
    <div className="mb-7">
      <div className="flex items-start gap-3">
        <div className="brand-gradient w-10 h-10 rounded-xl flex items-center justify-center font-heading font-black text-white shrink-0">C</div>
        <p className="font-heading font-bold text-xl sm:text-2xl leading-snug text-foreground pt-1" data-testid="onboarding-question">
          {children}
        </p>
      </div>
      {subtitle && <p className="text-sm text-muted-foreground mt-3 sm:ml-[52px] leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function Chip({ active, children, testid, onClick }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className={`px-5 py-3 rounded-xl border text-left font-medium transition-colors ${
        active ? "border-primary bg-primary/10 text-foreground" : "border-border bg-card hover:border-primary/50 text-foreground"
      }`}
    >
      {children}
    </button>
  );
}

export function FieldLabel({ children }) {
  return <p className="text-sm font-semibold text-foreground mb-2">{children}</p>;
}
